import React, { useEffect } from 'react';
import { Message } from '@meitu/saas-ui';
import type { Editor } from '@meitu/saas-editor-core';
import { WATERMARK_TYPE, type WatermarkLayer } from '@meitu/saas-editor-core/es/layers/watermark-layer';
import { useLocaleStore } from '@/i18n';

type AddWatermarkProps = {
    editor: Editor;
    url: string;
    setUrl: Function;
};
const AddWatermark: React.FC<AddWatermarkProps> = React.memo(({ editor, url, setUrl }) => {
    const stageSize = editor.services.frame.getActiveFrameSize();

    const { $t } = useLocaleStore();

    useEffect(() => {
        const fn = async () => {
            editor.services.mask.show({
                loading: true,
                background: true,
            });
            await editor
                .getInstance<WatermarkLayer>('WatermarkLayer')
                .addWatermarkLayer(WATERMARK_TYPE.IMG, stageSize, url);
            editor.services.mask.hide();
            Message.success($t((v) => v.collapse.watermarkCollapse.addSuccessText));
            setUrl('');
        };
        url && fn();
    }, [url]);
    return null;
});

export default AddWatermark;
